module.exports = __webpack_public_path__ + "img/product_img3.691b4ed3.png";